// ---------------------------------------------------------------------------
// Blockquote Renderer
// ---------------------------------------------------------------------------
// Foundational primitive — publishes the editor `Blockquote` block as a
// semantic <blockquote> with <footer> attribution. Distinct from the
// `testimonial-grid` block, which is a multi-card customer-proof grid.

import { registerRenderer } from "../registry.js";
import type { RenderContext } from "../types.js";
import { text } from "../escape.js";

interface BlockquoteProps {
  quote?: string;
  author?: string;
  role?: string;
}

function render(props: Record<string, unknown>, _ctx: RenderContext): string {
  const p = props as BlockquoteProps;

  const quote = typeof p.quote === "string" ? p.quote.trim() : "";
  if (!quote) {
    return "<!-- blockquote missing quote -->";
  }

  const author = typeof p.author === "string" ? p.author.trim() : "";
  const role = typeof p.role === "string" ? p.role.trim() : "";

  const footerParts: string[] = [];
  if (author) {
    footerParts.push(`<span class="ease-blockquote__author">${text(author)}</span>`);
  }
  if (role) {
    footerParts.push(`<span class="ease-blockquote__role">${text(role)}</span>`);
  }
  const footerHtml = footerParts.length
    ? `\n    <footer class="ease-blockquote__footer">${footerParts.join("")}</footer>`
    : "";

  return `<section class="ease-section ease-blockquote">
  <blockquote class="ease-blockquote__quote" cite="">
    <p class="ease-blockquote__text">${text(quote)}</p>${footerHtml}
  </blockquote>
</section>`;
}

registerRenderer("blockquote", { render });
